//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../helpers/firebase_helper";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

import { getAuthHeader } from "../../helpers/jwt-token-access/auth-token-header";

import {
  apiError,
  apiSuccess,
  contractSuccess,
  mileStoneSuccess,
  hicSuccess,
  subContractorSuccess,
  projectSuccess,
  changeOrderSuccess,
  subContractSuccess,
} from "./reducer";

import apiUrl, { localPath } from "slices/apiEndpoint";
import { cleanMoney } from "components/AddMilestoneDialog";
import api from "Common/api";

export const createProject = (project: any) => async (dispatch: any) => {
  const headers = getAuthHeader();
  if (!headers) {
    return;
  }
  try {
    const response = await api.post(
      `/contract/create`,
      {
        ...project,
      },
      { headers }
    );
    let data = response;
    if (data) {
      dispatch(apiSuccess(data));
      return data;
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const updateProject = (project: any) => async (dispatch: any) => {
  const headers = getAuthHeader();
  if (!headers) {
    return;
  }
  try {
    const response = await api.patch(
      `/contract/update-project`,
      {
        ...project,
      },
      { headers }
    );
    let data = response;
    if (data) {
      dispatch(apiSuccess(data));
      return data;
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const createMileStones = (milestones: any) => async (dispatch: any) => {
  const headers = getAuthHeader();
  if (!headers) {
    return;
  }
  try {
    const response = await api.post(
      `/contract/create-milestone`,
      {
        projectId: milestones.projectId,
        userId: getDecodeId(),
        totalCost: milestones.totalCost,
        milestones: milestones.milestones,
      },
      { headers }
    );
    let data = response.data;
    //console.log(data, "ddd")
    if (data) {
      dispatch(mileStoneSuccess(data));
      return data;
    }
  } catch (error) {
    dispatch(apiError(error));
    throw error;
  }
};

export const createSubContractor =
  (subcontractor: any) => async (dispatch: any) => {
    const headers = getAuthHeader();
    if (!headers) {
      return;
    }
    try {
      const response = await api.post(
        `/contract/create-subcontractor`,
        {
          ...subcontractor,
        },
        { headers }
      );
      let data = response.data;
      //console.log(data, "ddd")
      if (data) {
        dispatch(subContractorSuccess(data));
      }
    } catch (error) {
      dispatch(apiError(error));
    }
  };

  export const createHicContract = (hicContract: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const headers = getAuthHeader();
        if (!headers) {
          reject(new Error("No auth headers found"));
          return;
        }
  
        const response = await api.post(
          `/contract/create-hic-project`,
          {
            projectId: hicContract.projectId,
            address: hicContract.projectAddress,
            city: hicContract.city,
            zip: hicContract.zip,
            state: hicContract.state,
            federalTaxId: hicContract.federalTaxId,
            acknowledgment:hicContract.acknowledgment,
            additionalHomeOwnerName: hicContract.additionalHomeownerName,
            startDate: hicContract.startDate,
            completionDate: hicContract.endDate,
            substantialCompletionDate: hicContract.substantialCompletionDate,
            projectCostModel: hicContract.projectCostModel,
            totalAllowance: hicContract.allowances,
            workDescription: hicContract.descriptionOfWork,
            paymentSchedule: hicContract.paymentSchedule || null,
            contractorAuthorizedRepresentative:
              hicContract.contractorAuthorizedRepresentative,
            homeownerAuthorizedRepresentative:
              hicContract.authorizedRepresentative,
            contractorInsuranceOption: hicContract.contractorInsurance,
            contractorInsuranceProviderName: hicContract.insuranceProviderName,
            workerCompensationInsuranceOption:
              hicContract.workersCompensationInsurance,
            contractFileName: hicContract.documentName,
            homeownerId: hicContract.homeownerId,
            workerCompensationInsuranceLimit:
             cleanMoney(hicContract.workersCompensationInsuranceLimit) ,
            totalSalesPrice: hicContract.totalSalesPrice,
            contractorSignatureUrl: null,
            homeownerSignatureUrl: null,
            contractorSentAt: null,
            homeownerSentAt: null,
            additionalHomeownerSignatureUrl: null,
            previousCorporation: hicContract.previousCorporation || null,
            extraData:
              hicContract.extraData &&
              typeof hicContract.extraData === "object" &&
              !Array.isArray(hicContract.extraData)
                ? hicContract.extraData
                : {},
            userId: getDecodeId(),
            scopeUrl: hicContract?.scopeUrl || null,
            saveAsDraft: Boolean(hicContract.saveAsDraft),
          },
          { headers }
        );
  console.log(response)
        const data = response;
        if (data) {
          dispatch(hicSuccess(data));
          resolve(data); // ✅ resolve the promise with the response
        } else {
          reject(new Error("No data returned from API"));
        }
      } catch (error: any) {
        dispatch(apiError(error));
        reject(error); // ✅ reject promise on error
      }
    });
  };
  

export const createChangeOrder = (co: any) => async (dispatch: any) => {
  const headers = getAuthHeader();
  if (!headers) {
    return;
  }
  try {
    const response = await api.post(
      `/contract/create-change-order`,
      {
        projectId: co.projectId,
        address: co.projectAddress,
        city: co.city,
        zip: co.zip,
        state: co.state,
        additionalHomeOwnerName: co.additionalHomeownerName,
        workDescription: co.descriptionOfWork,
        priceOfWork: co.priceForWork,
        additionalTime: co.additionalTimeToComplete,
        grossContractTotalPrior: co.adjustedGrossContractPrior,
        grossContractTotal: co.adjustedGrossContractTotal,
        netChange: co.netChangePrior,
        halfPriceOfWork: null,
        contractFileName: co.documentName,
        homeownerId: co.homeownerId,
        totalSalesPrice: co.totalSalesPrice,
        contractorSignatureUrl: null,
        homeownerSignatureUrl: null,
        contractSentAt: null,
        homeownerSentAt: null,
        userId: getDecodeId(),
      },
      { headers }
    );
    let data = response.data;
    //console.log(data, "ddd")
    if (data) {
      dispatch(changeOrderSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const createSubContract =
  (subContract: any) => async (dispatch: any) => {
    const headers = getAuthHeader();
    if (!headers) {
      return;
    }
    try {
      const response = await api.post(
        `/contract/create-sub-contract`,
        {
          projectSubId: subContract.subContractorId,
          projectId: subContract.projectId,
          state: subContract.state,
          additionalHomeOwnerName: subContract.additionalHomeownerName,
          contractorAuthorizedRepresentative:
            subContract.contractorAuthorizedRepresentative,
          contractorInsuranceOption: subContract.contractorInsurance,
          contractorInsuranceProviderName: subContract.insuranceProviderName,
          workerCompensationInsuranceOption:
            subContract.workersCompensationInsurance,
          workerCompensationInsuranceLimit:
           cleanMoney(subContract.workersCompensationInsuranceLimit) ,
          descriptionOfServices: subContract.descriptionOfServices,
          subContratorResponsibilities:
            subContract.subcontractorResponsibilities,
          descriptionOfOtherResponsibilities: subContract.descriptionOfWork,
          commencementDate: subContract.subcontractorStartDate,
          completionDateOptions: subContract.completionDateOption,
          completionDateSpecific: subContract.completionDateSpecific,
          completionDateOther: subContract.completionDateOther,
          substantialCompletionDateOptions:
            subContract.substantialCompletionDateOption,
          substantialCompletionDateSpecific:
            subContract.substantialCompletionDateSpecific,
          substantialCompletionDateOther:
            subContract.substantialCompletionDateOther,
          paymentAmountOptions: subContract.paymentAmountOption,
          paymentAmountTotalAmount: cleanMoney(subContract.totalAmount) ,
          paymentAmountHourlyRate: cleanMoney(subContract.hourlyRate) ,
          paymentAmountOtherDescription: subContract.otherDescription,
          paymentMethodOptions: subContract.paymentMethodOption,
          paymentMethodOptionsOther: subContract.otherPaymentMethod,
          paymentFrequencyOptions: subContract.paymentFrequencyOption,
          paymentFrequencyOptionsOther: subContract.otherPaymentFrequency,
          rightToSubcontractingOptions: subContract.rightToSubcontract,
          assignmentRightOptions: subContract.assignmentRight,
          subcontractorInsuranceOption: subContract.subContractorInsurance,
          subContractorInsuranceProviderName:
            subContract.subInsuranceProviderName,
          subcontractorWorkerCompensationInsuranceOptions:
            subContract.subWorkersCompensationInsurance,
          subcontractorWorkerCompensationInsuranceLimit:
            subContract.subWorkersCompensationInsuranceLimit,
          subcontractorAuthorizedRepresentative:
            subContract.subcontractorAuthorizedRepresentative,
          additionalProvisions: subContract.additionalProvision,
          fileName: subContract.documentName,
          contractorSignatureUrl: null,
          subcontractorSignatureUrl: null,
          contractorSignedAt: null,
          subContractorSignedAt: null,
          contractorSentAt: null,
          subcontractorSentAt: null,
          scopeUrl:subContract?.scopeUrl||null,
          userId: getDecodeId(), // Assuming getDecodeId returns the userId
        },
        { headers }
      );

      const data = response.data;
      if (data) {
        dispatch(subContractSuccess(data)); // Assuming subContractSuccess is an action creator
      }
    } catch (error) {
      dispatch(apiError(error)); // Assuming apiError is an action creator for handling API errors
    }
  };

export const getContractsById = () => async (dispatch: any) => {
  const headers = getAuthHeader();
  if (!headers) {
    return;
  }
  
  try {
    const response = await api.get(
      `/contract/getContract/${getDecodeId()}`,
      { headers }
    );
    let data = response;
    //console.log(data, "ddd")
    if (data) {
      dispatch(contractSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};
export const getSubContractsById = () => async (dispatch: any) => {
  const headers = getAuthHeader();
  if (!headers) {
    return;
  }
  
  try {
    const response = await api.get(
      `/contract/getSubContract/${getDecodeId()}`,
      { headers }
    );
    let data = response;
    //console.log(data, "ddd")
    if (data) {
      dispatch(contractSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};
export const getSubcontractorContractsById = () => async (dispatch: any) => {
  const headers = getAuthHeader();
  if (!headers) {
    return;
  }
  try {
    const response = await api.get(
      `/contract/get-subcontractor-contract/${getDecodeId()}`,
      { headers }
    );
    let data = response;
    //console.log(data, "ddd")
    if (data) {
      dispatch(contractSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const getHomeownerContractsById = () => async (dispatch: any) => {
  const headers = getAuthHeader();
  if (!headers) {
    return;
  }
  try {
    const response = await api.get(
      `/contract/get-homeowner-contract/${getDecodeId()}`,
      { headers }
    );
    let data = response;
    //console.log(data, "ddd")
    if (data) {
      dispatch(contractSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const getInspectorContractsById = () => async (dispatch: any) => {
  const headers = getAuthHeader();
  if (!headers) {
    return;
  }
  try {
    const response = await api.get(
      `/contract/get-inspector-contract/${getDecodeId()}`,
      { headers }
    );
    let data = response;
    //console.log(data, "ddd")
    if (data) {
      dispatch(contractSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const getSingleProjectById =
  (projectId: any) => async (dispatch: any) => {
    const headers = getAuthHeader();
    if (!headers) {
      return;
    }
    try {
      const response = await api.get(
        `/contract/get-project/${projectId}`,
        { headers }
      );
      let data = response.data.project;
      if (data) {
        dispatch(projectSuccess(data));
      }
      return data || null;
    } catch (error) {
      dispatch(apiError(error));
      return null;
    }
  };

export const getSignedContracts = () => async (dispatch: any) => {
  const headers = getAuthHeader();
  if (!headers) {
    return;
  }
  let userType = getDecodeUserType();
  try {
    const response = await api.get(`/contract/get-signed-projects`, {
      headers,
    });
    let data = response as any
    //console.log(data, "ddd")
    if (data && userType === "admin") {
      dispatch(contractSuccess(data.result ? data : data.data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const requestInspection = (ri: any) => async (dispatch: any) => {
  const headers = getAuthHeader();
  if (!headers) {
    return;
  }
  try {
    const response = await api.post(
      `/contract/request-inspection`,
      {
        inspections: [
          {
            type: ri.type,
            documentUrl: ri.documentUrl,
            milestoneId: ri.milestoneId,
          },
        ],
        userId: getDecodeId(),
      },
      { headers }
    );
    let data = response.data;
    //console.log(data, "ddd")
    if (data) {
      //dispatch(subContractorSuccess(data));
      return data;
    }
  } catch (error) {
    dispatch(apiError(error));
    return error;
  }
};

export const assignContract =
  (projectid: any, inspectorId: any) => async (dispatch: any) => {
    const headers = getAuthHeader();
    if (!headers) {
      return;
    }
    try {
      const response = await api.post(
        `/contract/assign-inspector`,
        {
          projectId: projectid,
          inspectorId: inspectorId,
        },
        { headers }
      );
      let data = response;
      //console.log(data, "ddd")
      //dispatch(contractSuccess(data.data));
      return data;
    } catch (error) {
      dispatch(apiError(error));
      throw error;
    }
  };

export const acceptContractTerms = (term: any) => async (dispatch: any) => {
  const headers = getAuthHeader();
  if (!headers) {
    return;
  }
  try {
    const response = await api.post(
      `/contract/accept-terms`,
      {
        isAccepted: term,
        contId: getDecodeId(),
      },
      { headers }
    );
    const data = response.data;
    // Uncomment and adjust the line below if you have a success action to dispatch
    // dispatch(contractSuccess(data));
  } catch (error) {
    console.error(error);
    dispatch(apiError(error));
  }
};

export const downloadCancelForm = (homeownerID:any,projectID:any) => async (dispatch: any) => {
  const headers = getAuthHeader();
  if (!headers) {
    return;
  }
  try {
    const response = await api.post(
      `/contract/download-cancel`,
      {
        userId: getDecodeId(),
        homeownerID:homeownerID,
        projectID:String(projectID) 
      },
      { headers }
    );
    const data = response;
    return data;
  } catch (error) {
    console.error(error);
    dispatch(apiError(error));
  }
};

function getDecodeId() {
  const token = localStorage.getItem("authUser");
  let decoded: any = "";
  if (token !== null) {
    decoded = jwtDecode(token);
  } else {
    console.error("Token is null");
  }
  return decoded.userId;
}

function getDecodeUserType() {
  const token = localStorage.getItem("authUser");
  let decoded: any = "";
  if (token !== null) {
    decoded = jwtDecode(token);
  } else {
    console.error("Token is null");
  }
  return decoded.userType;
}
